import { sendEmailProducerCode } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailProducerCode);
};
export default useSendEmail;
